var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsStoreIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams",
    transform: "translate(-910 -609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "teams-fill-svgrepo-com",
    transform: "translate(907.304 606.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M19.51,7.8a1.465,1.465,0,1,0-1.465-1.465A1.465,1.465,0,0,0,19.51,7.8Z",
    transform: "translate(-4.605 -0.561)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M19.021,16.154a2.3,2.3,0,0,0,.288.018h.011A2.274,2.274,0,0,0,21.593,13.9V10.6a.619.619,0,0,0-.619-.619H19.212a1.3,1.3,0,0,1,.151.633v3.743A4.355,4.355,0,0,1,19.021,16.154Z",
    transform: "translate(-4.898 -2.096)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M16.9,15.856a2.267,2.267,0,0,1-.718-1.658V10.986h.928v3.7A2.962,2.962,0,0,1,16.9,15.856Z",
    transform: "translate(-4.046 -2.396)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M12.93,7.222A2.116,2.116,0,1,0,10.6,5.116c0,.04,0,.08,0,.12h1.028a1.3,1.3,0,0,1,1.3,1.3Z",
    transform: "translate(-2.372)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M11.806,8.426V8.2h-.284A2.127,2.127,0,0,0,11.806,8.426Z",
    transform: "translate(-2.648 -1.558)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M8.276,14.5q0-.063,0-.126v-.75h.331v-3.15H9.833V9.986h1V14.5Z",
    transform: "translate(-1.674 -2.096)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M8.695,15.9h2.366a1.3,1.3,0,0,0,1.3-1.3V9.986h2.61a.612.612,0,0,1,.6.626v3.757a3.672,3.672,0,0,1-3.581,3.757A3.673,3.673,0,0,1,8.695,15.9Z",
    transform: "translate(-1.8 -2.096)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M9.262,7.2H3.292a.6.6,0,0,0-.6.6v5.969a.6.6,0,0,0,.6.6H9.262a.6.6,0,0,0,.6-.6V7.792A.6.6,0,0,0,9.262,7.2Zm-4.6,2.437H5.884v3.15h.7V9.632H7.809v-.7H4.659Z",
    transform: "translate(0 -1.258)",
    fill: "#8a8a8a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 14,
    height: 14,
    transform: "translate(910 609)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsStoreIcon);
export default __webpack_public_path__ + "static/media/teams-store-icon.5147494bc8f6224785f38f7f92a95b83.svg";
export { ForwardRef as ReactComponent };